import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';



const Toolbar = () => {

     const [selectedBrand, setSelectedBrand] = useState('localhost');
    
    
         useEffect(() => {
        const hostname = (window.location.hostname || '').toLowerCase();
        const origin = (window.location.origin || '').toLowerCase();
        const search = (window.location.search || '').toLowerCase();
        const params = new URLSearchParams(window.location.search);
        const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();
    
        const isBeetbuzz = hostname.includes('betbuz65') || origin.includes('betbuz65') || brand.includes('betbuz65');
        const isLocalhost = hostname.includes('localhost') || origin.includes('localhost') || brand.includes('localhost');
        
    
        const selectedBrand = isBeetbuzz ? 'betbuz65' : isLocalhost ? 'localhost'  : 'default';
    
        localStorage.setItem('brand', selectedBrand);
        setSelectedBrand(selectedBrand);
      
        
      
      
       
      }, []);
    
    return (
        <div id="toolbar" className="toolbar">
            <ul>
                <li className="home">
                    <NavLink to="/" activeClassName="active">
                        <span 
                            className="item-icon" 
                            style={{
                                backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/toolbar-icon/toolbar-icon-home.svg?v=1729676340443")',
                            }}
                        ></span>
                        <span 
                            className="item-icon-active" 
                            style={{
                                backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/toolbar-icon/toolbar-icon-home.svg?v=1729676340443")',
                            }}
                        ></span>
                        <p>Home</p>
                    </NavLink>
                </li>
{selectedBrand === 'betbuz65' ? (
    <li className="promotion">
                    <NavLink to="/exchange" activeClassName="active">
                        <span 
                            className="item-icon" 
                            style={{
                                backgroundImage: 'url("https://img.b4711gb.com/bgb/h5/assets/images/icon-set/sports-icon/icon-exchange.png")',
                            }}
                        ></span>
                        <span 
                            className="item-icon-active" 
                            style={{
                                backgroundImage: 'url("https://img.b4711gb.com/bgb/h5/assets/images/icon-set/sports-icon/icon-exchange.png")',
                            }}
                        ></span>
                        <p>Sports</p>
                    </NavLink>
                </li>
) : (
    <li className="promotion">
                    <NavLink to="/promotions" activeClassName="active">
                        <span 
                            className="item-icon" 
                            style={{
                                backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/toolbar-icon/toolbar-icon-promotion.svg?v=1729676340443")',
                            }}
                        ></span>
                        <span 
                            className="item-icon-active" 
                            style={{
                                backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/toolbar-icon/toolbar-icon-promotion.svg?v=1729676340443")',
                            }}
                        ></span>
                        <p>Promotions</p>
                    </NavLink>
                </li>
)}

               



                <li className="deposit">
                    <NavLink to="/deposit" activeClassName="active">
                        <span 
                            className="item-icon" 
                            style={{
                                backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/toolbar-icon/toolbar-icon-deposit.svg?v=1729676340443")',
                            }}
                        ></span>
                        <span 
                            className="item-icon-active" 
                            style={{
                                backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/toolbar-icon/toolbar-icon-deposit.svg?v=1729676340443")',
                            }}
                        ></span>
                        <p>Deposit</p>
                    </NavLink>
                </li>

                <li className="mine">
                    <NavLink to="/account" activeClassName="active">
                        <span 
                            className="item-icon" 
                            style={{
                                backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/toolbar-icon/toolbar-icon-mine.svg?v=1729676340443")',
                            }}
                        ></span>
                        <span 
                            className="item-icon-active" 
                            style={{
                                backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/toolbar-icon/toolbar-icon-mine.svg?v=1729676340443")',
                            }}
                        ></span>
                        <p>My Account</p>
                    </NavLink>
                </li>
            </ul>
        </div>
    );
};

export default Toolbar;
